import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import './SignUp.css'
import { useSelector, useDispatch } from 'react-redux'
import {
  setRegistrationNum,
  setCompanyName,
  setAddress,
  setContact,
  setContactEmail
} from 'redux/actions/'
import DropZoneFileUpload from './fileUpload'
import { validatePhoneNumber } from 'utils/validatePhoneNumber'

export default function Login() {
  const dispatch = useDispatch()
  const {
    registrationNum,
    companyName,
    address,
    contactPerson,
    contactEmail
    // attachment
  } = useSelector(state => state.signup)

  const handlePhoneNumber = e => {
    const value = e.target.value
    const { validPhone } = validatePhoneNumber(value)
    dispatch(setContact(validPhone))
  }

  return (
    <>
      <Typography
        variant="h2"
        align="center"
        style={{
          padding: '25px 0'
        }}>
        Please give us your company informations
      </Typography>
      <Grid style={{ textAlign: 'left', marginBottom: '2rem' }} container>
        <Grid item sm={12} xs={12} md={12} lg={12}>
          <label for="registrationNum">Registration No.</label>
          <input
            className="input"
            id="registrationNum"
            placeholder="65365437"
            type="text"
            value={registrationNum}
            onChange={e =>
              dispatch(setRegistrationNum(e.target.value.replace(/\D/g, '')))
            }
          />
        </Grid>
        <Grid item container spacing={2}>
          <Grid item sm={6} xs={12} md={6} lg={6}>
            <label for="companyName">Company Name</label>
            <input
              className="input"
              id="companyName"
              type="text"
              placeholder="Company Name"
              value={companyName}
              onChange={e => dispatch(setCompanyName(e.target.value))}
            />
          </Grid>
          <Grid item sm={6} xs={12} md={6} lg={6}>
            <label for="companyAddress">Company Address</label>
            <input
              className="input"
              type="text"
              id="companyAddress"
              placeholder="Iraq / Erbil / Baharkah st."
              value={address}
              onChange={e => dispatch(setAddress(e.target.value))}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item sm={6} xs={12} md={6} lg={6}>
            <label>Contact Person</label>
            <input
              className="input"
              type="text"
              placeholder="+964 77* 000 00 00"
              value={contactPerson}
              onChange={handlePhoneNumber}
            />
          </Grid>
          <Grid item sm={6} xs={12} md={6} lg={6}>
            <label>Contact Email</label>
            <input
              className="input"
              type="text"
              placeholder="name@domain.com"
              value={contactEmail}
              onChange={e => dispatch(setContactEmail(e.target.value))}
            />
          </Grid>
        </Grid>
        <Grid item sm={12} xs={12} md={12} lg={12}>
          <label>Business License</label>
          <div className="button-wrap">
            <DropZoneFileUpload>Upload</DropZoneFileUpload>
          </div>
        </Grid>
      </Grid>
    </>
  )
}
